import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bb_admin_token", data.token);
      toast.success("Login effettuato");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login fallito");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={handleSubmit} className="bb-card w-full max-w-md p-10">
        <div className="flex items-center gap-3 mb-2">
          <Lock size={20} style={{ color: "var(--bb-primary)" }} />
          <span className="bb-eyebrow">Area Riservata</span>
        </div>
        <h1 className="bb-display text-4xl mb-8">ADMIN LOGIN</h1>
        <div className="space-y-5">
          <div>
            <label className="bb-label">Email</label>
            <input
              data-testid="admin-email"
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bb-input"
            />
          </div>
          <div>
            <label className="bb-label">Password</label>
            <input
              data-testid="admin-password"
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bb-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="bb-btn-primary w-full justify-center"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Accedi"}
          </button>
        </div>
      </form>
    </main>
  );
}
